import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { EntryDictionary, LogInType } from '@generativ/ms-student-types';
import { ContentfulService } from '../../../shared/contentful.service';
import { ActivatedRoute, RouterOutlet } from '@angular/router';

const embeddedBodyClass = 'auth-embedded';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet]
})
export class AuthComponent implements OnInit, OnDestroy {

  content: LogInType;
  isEmbedded: boolean;

  constructor(
    private contentfulService: ContentfulService,
    route: ActivatedRoute
  ) {
    this.isEmbedded = route.snapshot.data['embedded'] === true;
    if (this.isEmbedded) {
      document.body.classList.add(embeddedBodyClass);
    }
  }

  ngOnInit(): void {
    if (this.isEmbedded) {
      return;
    }

    this.contentfulService.getStudentEntry(EntryDictionary.LogIn.logIn).then(
      (entry) => {
        this.content = new LogInType(entry);
      },
    );
  }

  ngOnDestroy() {
    document.body.classList.remove(embeddedBodyClass);
  }
}
